import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ContactService } from '../../services/contact.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-contacts',
  standalone: true,
  imports: [CommonModule, FormsModule],
  template: `
    <div class="contacts-layout">
      <aside class="sidebar">
        <div class="logo" (click)="goHome()">
          <svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" stroke-width="2" fill="none"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline><line x1="16" y1="13" x2="8" y2="13"></line><line x1="16" y1="17" x2="8" y2="17"></line><polyline points="10 9 9 9 8 9"></polyline></svg>
          SignDoc Pro
        </div>
        
        <nav class="nav-links">
          <a (click)="goToHub()">
            <svg viewBox="0 0 24 24" width="18" height="18" stroke="currentColor" stroke-width="2" fill="none"><polyline points="15 18 9 12 15 6"></polyline></svg>
            Hub
          </a>
          <a (click)="goHome()">
            <svg viewBox="0 0 24 24" width="18" height="18" stroke="currentColor" stroke-width="2" fill="none"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path><polyline points="9 22 9 12 15 12 15 22"></polyline></svg>
            Dashboard
          </a>
          <a class="active">
            <svg viewBox="0 0 24 24" width="18" height="18" stroke="currentColor" stroke-width="2" fill="none"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="9" cy="7" r="4"></circle><path d="M23 21v-2a4 4 0 0 0-3-3.87"></path><path d="M16 3.13a4 4 0 0 1 0 7.75"></path></svg>
            Kontakte
          </a>
          <a (click)="goToSettings()">
            <svg viewBox="0 0 24 24" width="18" height="18" stroke="currentColor" stroke-width="2" fill="none"><circle cx="12" cy="12" r="3"></circle><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"></path></svg>
            Einstellungen
          </a>
        </nav>
      </aside>

      <main class="content">
        <header class="header">
          <h1>Kontaktbuch</h1>
          <button class="btn-primary" (click)="showAddModal = true">
            <svg viewBox="0 0 24 24" width="18" height="18" stroke="currentColor" stroke-width="2" fill="none"><line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line></svg>
            Kontakt hinzufügen
          </button>
        </header>

        <div class="contacts-table-container glass">
          <table class="modern-table">
            <thead>
              <tr>
                <th>Name</th>
                <th>E-Mail Adresse</th>
                <th>Telefonnummer</th>
                <th>Hinzugefügt am</th>
                <th class="text-right">Aktionen</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let contact of contacts">
                <td>
                  <div class="name-cell">
                    <div class="contact-avatar-small">{{ contact.name.charAt(0).toUpperCase() }}</div>
                    <span>{{ contact.name }}</span>
                  </div>
                </td>
                <td>{{ contact.email }}</td>
                <td>{{ contact.phone || '-' }}</td>
                <td>{{ contact.createdAt | date:'dd.MM.yyyy' }}</td>
                <td class="text-right">
                  <button class="btn-icon delete" (click)="deleteContact(contact.id)" title="Löschen">
                    <svg viewBox="0 0 24 24" width="18" height="18" stroke="currentColor" stroke-width="2" fill="none"><polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path><line x1="10" y1="11" x2="10" y2="17"></line><line x1="14" y1="11" x2="14" y2="17"></line></svg>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div *ngIf="contacts.length === 0" class="empty-state">
          <p>Noch keine Kontakte gespeichert.</p>
        </div>
      </main>

      <!-- ADD MODAL -->
      <div class="modal-overlay" *ngIf="showAddModal" (click)="showAddModal = false">
        <div class="modal-card glass" (click)="$event.stopPropagation()">
          <h2>Neuer Kontakt</h2>
          <div class="form-group">
            <label>Name</label>
            <input [(ngModel)]="newContact.name" placeholder="Vollständiger Name" class="modern-input">
          </div>
          <div class="form-group">
            <label>E-Mail</label>
            <input [(ngModel)]="newContact.email" placeholder="E-Mail Adresse" class="modern-input">
          </div>
          <div class="form-group">
            <label>Telefonnummer (für WhatsApp 2FA)</label>
            <input [(ngModel)]="newContact.phone" placeholder="+49 123 456789" class="modern-input">
          </div>
          <div class="modal-actions">
            <button class="btn-secondary" (click)="showAddModal = false">Abbrechen</button>
            <button class="btn-primary" (click)="addContact()" [disabled]="!newContact.name || !newContact.email">Speichern</button>
          </div>
        </div>
      </div>
    </div>
  `,
  styles: [`
    @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap');

    :host {
      font-family: 'Inter', sans-serif;
      display: block;
      min-height: 100vh;
      background-color: #0f172a;
      color: #f8fafc;
    }

    .contacts-layout {
      display: flex;
      height: 100vh;
    }

    .sidebar {
      width: 280px;
      background: rgba(30, 41, 59, 0.5);
      backdrop-filter: blur(16px);
      border-right: 1px solid rgba(255, 255, 255, 0.05);
      padding: 2rem;
      display: flex;
      flex-direction: column;
      gap: 3rem;
    }

    .logo {
      display: flex;
      align-items: center;
      gap: 0.75rem;
      font-size: 1.25rem;
      font-weight: 700;
      color: #38bdf8;
      cursor: pointer;
    }

    .nav-links {
      display: flex;
      flex-direction: column;
      gap: 0.5rem;
    }

    .nav-links a {
      display: flex;
      align-items: center;
      gap: 0.75rem;
      padding: 0.75rem 1rem;
      border-radius: 0.75rem;
      color: #94a3b8;
      text-decoration: none;
      transition: all 0.2s;
      cursor: pointer;
    }

    .nav-links a:hover, .nav-links a.active {
      background: rgba(56, 189, 248, 0.1);
      color: #38bdf8;
    }

    .content {
      flex: 1;
      padding: 3rem;
      overflow-y: auto;
    }

    .header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 3rem;
    }

    .header h1 { margin: 0; font-size: 2rem; font-weight: 700; }

    .contacts-table-container {
      overflow: hidden;
      margin-bottom: 2rem;
    }

    .modern-table {
      width: 100%;
      border-collapse: collapse;
      text-align: left;
    }

    .modern-table th {
      padding: 1.25rem 1.5rem;
      background: rgba(255, 255, 255, 0.02);
      color: #94a3b8;
      font-size: 0.8rem;
      text-transform: uppercase;
      font-weight: 700;
      letter-spacing: 0.05em;
      border-bottom: 1px solid rgba(255, 255, 255, 0.05);
    }

    .modern-table td {
      padding: 1rem 1.5rem;
      border-bottom: 1px solid rgba(255, 255, 255, 0.03);
      color: #e2e8f0;
      font-size: 0.95rem;
    }

    .modern-table tr:hover td {
      background: rgba(255, 255, 255, 0.02);
    }

    .name-cell {
      display: flex;
      align-items: center;
      gap: 1rem;
    }

    .contact-avatar-small {
      width: 32px; height: 32px; border-radius: 50%;
      background: linear-gradient(135deg, #0ea5e9, #4f46e5);
      display: flex; align-items: center; justify-content: center;
      font-size: 0.85rem; font-weight: 700; color: white;
    }

    .text-right { text-align: right; }

    .glass {
      background: rgba(30, 41, 59, 0.7);
      backdrop-filter: blur(16px);
      border: 1px solid rgba(255, 255, 255, 0.05);
      border-radius: 1rem;
    }

    .btn-icon {
      background: transparent; border: none; color: #64748b;
      padding: 0.5rem; border-radius: 0.5rem; cursor: pointer;
      transition: all 0.2s;
    }
    .btn-icon:hover { background: rgba(255, 255, 255, 0.05); color: #f1f5f9; }
    .btn-icon.delete:hover { color: #ef4444; background: rgba(239, 68, 68, 0.1); }

    .btn-primary {
      background: linear-gradient(135deg, #0ea5e9, #4f46e5);
      color: white; border: none; padding: 0.75rem 1.5rem;
      border-radius: 0.75rem; font-weight: 600; cursor: pointer;
      display: flex; align-items: center; gap: 0.5rem;
      transition: all 0.2s;
    }
    .btn-primary:hover { opacity: 0.9; transform: translateY(-1px); }

    .btn-secondary {
      background: rgba(255, 255, 255, 0.05);
      color: #f1f5f9; border: 1px solid rgba(255, 255, 255, 0.1);
      padding: 0.75rem 1.5rem; border-radius: 0.75rem; font-weight: 600; cursor: pointer;
    }

    .empty-state {
      text-align: center; padding: 5rem; color: #64748b;
    }

    .modal-overlay {
      position: fixed; top: 0; left: 0; right: 0; bottom: 0;
      background: rgba(0, 0, 0, 0.7); backdrop-filter: blur(4px);
      z-index: 100; display: flex; align-items: center; justify-content: center;
    }

    .modal-card {
      width: 450px; padding: 2.5rem;
    }

    .form-group { margin-bottom: 1.5rem; }
    .form-group label { display: block; margin-bottom: 0.5rem; font-size: 0.9rem; color: #94a3b8; }
    
    .modern-input {
      width: 100%; box-sizing: border-box; padding: 0.75rem 1rem; border-radius: 0.75rem;
      background: rgba(15, 23, 42, 0.8); border: 1px solid rgba(255, 255, 255, 0.1);
      color: white; font-family: 'Inter', sans-serif;
    }

    .modal-actions {
      display: flex; justify-content: flex-end; gap: 1rem; margin-top: 2rem;
    }
  `]
})
export class ContactsComponent implements OnInit {
  private contactService = inject(ContactService);
  private router = inject(Router);

  contacts: any[] = [];
  showAddModal = false;
  newContact = { name: '', email: '', phone: '' };

  ngOnInit() {
    this.loadContacts();
  }

  loadContacts() {
    this.contactService.getAll().subscribe(data => {
      this.contacts = data;
    });
  }

  addContact() {
    this.contactService.create(this.newContact).subscribe(() => {
      this.loadContacts();
      this.showAddModal = false;
      this.newContact = { name: '', email: '', phone: '' };
    });
  }

  deleteContact(id: string) {
    if (confirm('Möchten Sie diesen Kontakt wirklich löschen?')) {
      this.contactService.delete(id).subscribe(() => {
        this.loadContacts();
      });
    }
  }

  goHome() { this.router.navigate(['/pdf-signer']); }
  goToSettings() { this.router.navigate(['/pdf-signer/settings']); }
  goToHub() { this.router.navigate(['/launcher']); }
}
